//component entry file
import AnalystRating from "./components/analystRating/Index.vue";

export default AnalystRating;